import Vue from 'vue';

export default {
    survey({
        customerId,
        employeeId,
        arkona,
        stockNumber,
        vin,
        comfort,
        easyToDrive,
        exteriorFeatures,
        safetyFeatures,
        sizeAndSpace,
        interestInPurchase,
        comments,
    }) {
        const path = 'test-drive/survey';
        const payload = {
            customerId,
            employeeId,
            arkona,
            stockNumber,
            vin,
            comfort,
            easyToDrive,
            exteriorFeatures,
            safetyFeatures,
            sizeAndSpace,
            interestInPurchase,
            comments,
        };
        return Vue.axios.post(path, payload);
    },
    schedule({
        customerId,
        arkona,
        stockNumber,
        vin,
        apptDateTime,
        isRemote,
        addressLineOne,
        addressLineTwo,
        city,
        state,
        zip,
    }) {
        const path = 'test-drive/schedule';
        const payload = {
            customerId,
            arkona,
            stockNumber,
            vin,
            apptDateTime,
            isRemote,
            addressLineOne,
            addressLineTwo,
            city,
            state,
            zip,
        };
        return Vue.axios.post(path, payload);
    },
};
